import "@/App.css";
import React, { Suspense, lazy } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";

// Formular Online ships the DARK layout only (separate source tree from the
// amt-digital.de landing page — this is fonline/frontend, not frontend/).
// The amt-digital site keeps its own frontend/ with the light default and the
// ?style= runtime override; those mechanisms intentionally do NOT exist here.
const theme = "dark";

// eslint-disable-next-line no-console
console.info(`[theme] active: ${theme} (Formular Online build)`);

const Landing = lazy(() => import("./pages/LandingDark"));

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Suspense
          fallback={
            <div
              style={{
                minHeight: "100vh",
                background: "#020617",
              }}
            />
          }
        >
          <Routes>
            <Route path="/" element={<Landing />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
